import { useEffect } from 'react'
import { Redirect, useLocation } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { useAuth } from 'shared/hooks'
import { getCurrentAuthenticatedUser } from 'shared/store/auth/actions'
import { paths } from 'modules/Home/strings'
import { useSliderContent } from '../../hooks'
import { Header, RegisterForm, Slider, AccountInfo } from '../../components'
import { useError } from './Register.utils'
import {
  Container,
  FormWrapper,
  SliderWrapper,
  LanguageSelect,
} from './Register.style'

const Register = () => {
  const { isAuthenticated } = useAuth()
  const images = useSliderContent()
  const dispatch = useDispatch()
  const errorMessage = useError()
  const location = useLocation()
  const state = (location.state as { from: string }) || { from: '' }

  useEffect(() => {
    dispatch(getCurrentAuthenticatedUser())
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return isAuthenticated ? (
    <Redirect to={state.from || paths.home} />
  ) : (
    <Container container>
      <FormWrapper
        xs={6}
        item
        container
        direction="column"
        wrap="nowrap"
        justifyContent="flex-start"
      >
        <LanguageSelect />
        <Header error={errorMessage} />
        <RegisterForm />
        <AccountInfo />
      </FormWrapper>
      <SliderWrapper xs={6} item>
        <Slider items={images} />
      </SliderWrapper>
    </Container>
  )
}

export default Register
